import cn from "mcn";
import { useProductById } from "../../../../data";
import { ValueDisplay } from "./ValueDisplay";
import { RowPeriod } from "./RowPeriod";

type RootCellDisplayProps = {
  product: string;
  field: string;
  row: number;
  onMouseEnter?: () => void;
};

export const RootCellDisplay = ({ product, field, row, onMouseEnter }: RootCellDisplayProps) => {
  const productInfo = useProductById(product);

  return (
    <div
      className={cn(
        "flex w-max px-4 py-3 justify-center items-center gap-4",
        "rounded-lg bg-card border border-outline",
      )}
      onMouseEnter={onMouseEnter}
    >
      <p className="text-[14px] leading-[18px] font-medium text-foreground">
        {productInfo.data?.name}: <RowPeriod row={row} />
      </p>
      <ValueDisplay product={product} field={field} row={row} hideLabel={field === "value" || field === "fv"} />
    </div>
  );
};
